<template>
  <div>
    <router-view />
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <pro-sign-up
      :schemaForm="schema.schemaForm"
      :modelForm="model"
      :save="handleSignUp"
      :checkboxTerms="checkboxTerms"
      :handleEventsbox="handleEventsbox"
      :status="status"
    />
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import ProSignUp from '@/components/enter/ProSignUp.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProSignUpPage',
  components: {
    MainHeaderInfo,
    ProSignUp,
    VSnackBar,
  },
  data() {
    return {
      checkboxTerms: false,
      model: {},
    };
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('proSignUpPage', ['schema']),
    ...mapGetters('auth', ['status', 'msgError']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proSignUpPage', ['loadSchema']),
    ...mapActions('notifications', ['triggerSnackbar']),

    handleEventsbox(val) {
      this.valCheck = val;
    },

    async handleSignUp() {
      const { group1, group2 } = this.model;

      let model = { 
        ...group1, 
        ...group2,
        users_second_name: group1.users_second_name ?? null,
        users_third_name: group1.users_third_name ?? null,
        institution_code: group1.institution_code ?? '' 
      };

      if (this.valCheck !== undefined) {
        model.users_terms = Number(this.valCheck);
      } else {
        model.users_terms = this.users_terms;
      }

      this.$store.dispatch('auth/signUp', model).then(
        () => {
          if (this.status === 'success') {
            this.snackbar.visible = false;
            this.snackbar.visible = true;
            this.snackbar.content = this.schema.snackOk;
            
            this.$store.commit('auth/SET_STATUS', 'loaded');
            
            setTimeout(() => {
              this.snackbar.visible = false;
              this.$router.push({ name: 'login' });
            }, 4000);
          } else if (this.status === 'error') {
            this.snackbar.visible = false;
            this.snackbar.visible = true;
            this.snackbar.content = this.msgError;
            
            this.$store.commit('auth/SET_STATUS', 'loaded');
          }
        },
        () => {
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.schema.snackError;
          
          this.$store.commit('auth/SET_STATUS', 'loaded');
        }
      );
    },
  },
};
</script>
